import { render, staticRenderFns } from "./ShipmentForecast.vue?vue&type=template&id=49ceccfc&"
import script from "./ShipmentForecast.vue?vue&type=script&lang=ts&"
export * from "./ShipmentForecast.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentForecast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports